/* 
* File: \app\components\service\percenCategorySlider\percenCategorySlider.js
* Description: 横向列表滚动指令
* Create Date: 2020-05-11
* Author: he.jianbo
* Author Email: hjb2722404@163.com
* -----
* Last Modified: 2020-05-11 下午1:54:19
* Modified By: he.jianbo
* modify description: 
* -----
* HISTORY:
* 日期                    	作者	说明
* -----------	---	----------------------------------------------------------
 */

angular.module('app')
    .directive('percenCategorySlider', ['$document', function ($document, $element) {
        return {
            restrict: 'A',
            scope: {
                categoryHasSlider: '=', // 是否滚动
                categoryMenus: '=' // 菜单数据-数组
            },
            link: function (scope, element, attr, controller) {
                if (scope.categoryHasSlider) {
                    let width = parseInt(element.css('width'));
                    let contentWidth = 0;
                    scope.$watch('categoryMenus', function (newValue, oldValue, scope) {
                        let oLis = element.children();
                        let hasToLeft = false;
                        let hasToRight = false;
                        angular.forEach(oLis, function (item) {
                            if ($(item).css('display') !== 'none') {
                                contentWidth += parseInt($(item).css('width'));
                            }
                            if ($(item).hasClass('toLeft')){
                                hasToLeft = true;
                            }
                            if ($(item).hasClass('toRight')){
                                hasToRight = true;
                            }
                        });
                        if (contentWidth > width) {
                            if (!hasToLeft) {
                                element.prepend('<span class="toLeft" title="左移"><i class="iconfont icon-wenzixiangqingye-shangyiye"></i></span>');
                            }
                            if (!hasToRight) {
                                element.append('<span class="toRight" title="右移"><i class="iconfont icon-wenzixiangqingye-shangyiye"></i></span>');
                            }
                            let oLis = element.children();
                            let toLeft = oLis[0];
                            let toRight = oLis[oLis.length - 1];
                            let curIndex = 1;
                            let toRightList = [];
                            $(toRight).css('display', 'block');
                            $(toRight).bind('click', function () {
                                let oLis = element.children();
                                let hideWidth = parseInt($(oLis[curIndex]).css('width'));
                                toRightList.push(scope.categoryMenus.shift());
                                contentWidth -= hideWidth;
                                if (contentWidth <= width) {
                                    $(toRight).css('display', 'none');
                                }
                                curIndex++;
                                if (curIndex > 1){
                                    $(toLeft).css('display', 'block');
                                }
                            });
                            $(toLeft).bind('click', function () {
                                scope.categoryMenus.unshift(toRightList.pop());
                                let oLis = element.children();
                                let addWidth = parseInt($(oLis[curIndex]).css('width'));
                                contentWidth += addWidth;
                                curIndex--;
                                if (curIndex === 1) {
                                    $(toLeft).css('display', 'none');
                                    $(toRight).css('display', 'block');
                                }
                            });
                        }

                    });

                }
            }
        };
    }]);
